module.exports = __webpack_public_path__ + "img/certif_016.850f7671.jpg";